import React from 'react'
import { useTranslation } from 'react-i18next'
// @ts-ignore
import { Button } from '@netbasequid/core'
import { Theme, Page } from 'features/ui/types'
import { useDisplayTheme, usePage } from 'hooks/useUiState'
import { AutomationId } from 'utils/automationUtil'

interface GoToAnalysisButtonProps {
  onClick: () => void
  disabled?: boolean
}

const GoToAnalysisButton = ({ onClick, disabled }: GoToAnalysisButtonProps) => {
  const { t } = useTranslation()
  const theme = useDisplayTheme() as Theme
  const page = usePage()

  if (page === Page.LiveReport) {
    return null
  }
  return (
    <Button
      data-testid={AutomationId.insightModal.goToAnalysisButton}
      mode={theme}
      color="secondary"
      onClick={onClick}
      disabled={disabled}>
      {t('goToAnalysis')}
    </Button>
  )
}

export default GoToAnalysisButton
